import { Platform } from "react-native";
import Constants from "./Constants";

/**
 * Menu images.
 */
// Vivo
import vivo_main_menu from "../../assets/Vivo-menu/main-menu.png";
import vivo_member_card from "../../assets/Vivo-menu/member-card.png";
import vivo_my_history from "../../assets/Vivo-menu/my-history.png";
import vivo_Submit_claim from "../../assets/Vivo-menu/Submit-claim.png";
import vivo_faqs from "../../assets/Vivo-menu/faqs.png";
import vivo_logout from "../../assets/Vivo-menu/logout.png";

// Xiaomi
import xiaomi_main_menu from "../../assets/Xiaomi-menu/main-menu.png";
import xiaomi_member_card from "../../assets/Xiaomi-menu/member-card.png";
import xiaomi_my_history from "../../assets/Xiaomi-menu/my-history.png";
import xiaomi_Submit_claim from "../../assets/Xiaomi-menu/Submit-claim.png";
import xiaomi_faqs from "../../assets/Xiaomi-menu/faqs.png";
import xiaomi_logout from "../../assets/Xiaomi-menu/logout.png";

// Hisense
import hisense_main_menu from "../../assets/Hisense-menu/main-menu.png";
import hisense_member_card from "../../assets/Hisense-menu/member-card.png";
import hisense_my_history from "../../assets/Hisense-menu/my-history.png";
import hisense_Submit_claim from "../../assets/Hisense-menu/Submit-claim.png";
import hisense_faqs from "../../assets/Hisense-menu/faqs.png";
import hisense_logout from "../../assets/Hisense-menu/logout.png";

/**
 * Checkbox IMAGES
 */
import checkboxVivo from "../../assets/Vivo-menu/checkbox.png";
import checkboxXiaomi from "../../assets/Xiaomi-menu/checkbox.png";
import checkboxHisense from "../../assets/Hisense-menu/checkbox.png";

/**
 * How does it work IMAGES
 */
import Xiaomi from "../../assets/CIP-Flow-diagram.png";
import Vivo from "../../assets/Vivo-how-does-it-work.jpg";
import Hisense from "../../assets/Hisense-how-does-it-work.jpg";

/**
 * Brand header IMAGES
 */
import XiaomiLogo from "../../assets/mi-logo.png";
import VivoLogo from "../../assets/Vivo-logo.png";
import HisenseLogo from "../../assets/HisenseMobile-logo.png";

/**
 * Login IMAGES
 */
import XiaomiLogin from "../../assets/mi-logo.png";
import VivoLogin from "../../assets/Vivo-logo-blue.png";
import HisenseLogin from "../../assets/HisenseMobile-logo.png";

import delete_account_vivo from "../../assets/delete_account_vivo.png";
import delete_account_xiaomi from "../../assets/delete_account_xiaomi.png";
import delete_profile from "../../assets/delete_profile.png";

export const isWeb = () => {
	return Platform.OS === "web";
};

export const isAndroid = () => {
	return Platform.OS === "android";
};

export const isiOS = () => {
	return Platform.OS === "ios";
};

export const getBrandHeaderBackground = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return "#212121";
		case Constants.VivoURL:
			return "#fff";
		case Constants.HisenseURL:
			return "#28262b";
	}
};

export const getBrandHeaderTextColor = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return "#fff";
		case Constants.VivoURL:
			return "#1A1A1A";
		case Constants.HisenseURL:
			return "#fff";
	}
};

export const getBrandHeaderDividerColor = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return "#fff";
		case Constants.VivoURL:
			return "#d5d5d5";
		case Constants.HisenseURL:
			return "#fff";
	}
};

export const getBrandLeftMenuTextColor = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return "#fff";
		case Constants.VivoURL:
			return "gray.500";
		case Constants.HisenseURL:
			return "#fff";
	}
};

export const getBrandLeftMenuBackgroundColor = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return "#444444";
		case Constants.VivoURL:
			return "#fff";
		case Constants.HisenseURL:
			return "#00aaa6";
	}
};

export const getMenuImg = (menuItem) => {
	switch (menuItem) {
		case "Main Menu":
			switch (Constants.CIP_BRAND) {
				case Constants.XiaomiURL:
					return xiaomi_main_menu;
				case Constants.VivoURL:
					return vivo_main_menu;
				case Constants.HisenseURL:
					return hisense_main_menu;
			}

		case "My History":
			switch (Constants.CIP_BRAND) {
				case Constants.XiaomiURL:
					return xiaomi_my_history;
				case Constants.VivoURL:
					return vivo_my_history;
				case Constants.HisenseURL:
					return hisense_my_history;
			}

		case "FAQ's":
			switch (Constants.CIP_BRAND) {
				case Constants.XiaomiURL:
					return xiaomi_faqs;
				case Constants.VivoURL:
					return vivo_faqs;
				case Constants.HisenseURL:
					return hisense_faqs;
			}

		case "My Transactions":
			switch (Constants.CIP_BRAND) {
				case Constants.XiaomiURL:
					return xiaomi_member_card;
				case Constants.VivoURL:
					return vivo_member_card;
				case Constants.HisenseURL:
					return hisense_member_card;
			}

		case "Manage Card":
			switch (Constants.CIP_BRAND) {
				case Constants.XiaomiURL:
					return xiaomi_member_card;
				case Constants.VivoURL:
					return vivo_member_card;
				case Constants.HisenseURL:
					return hisense_member_card;
			}

		case "Submit Claim":
			switch (Constants.CIP_BRAND) {
				case Constants.XiaomiURL:
					return xiaomi_Submit_claim;
				case Constants.VivoURL:
					return vivo_Submit_claim;
				case Constants.HisenseURL:
					return hisense_Submit_claim;
			}

		case "Logout":
			switch (Constants.CIP_BRAND) {
				case Constants.XiaomiURL:
					return xiaomi_logout;
				case Constants.VivoURL:
					return vivo_logout;
				case Constants.HisenseURL:
					return hisense_logout;
			}

		case "Delete Profile":
			switch (Constants.CIP_BRAND) {
				case Constants.XiaomiURL:
					return delete_account_xiaomi;
				case Constants.VivoURL:
					return delete_account_vivo;
				case Constants.HisenseURL:
					return delete_profile;
			}
		default:
			// for hidden menus.
			return xiaomi_logout;
	}
};

export const getBrandHowDoesItWorkImage = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return Xiaomi;
		case Constants.VivoURL:
			return Vivo;
		case Constants.HisenseURL:
			return Hisense;
	}
};

export const getBrandLogo = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return XiaomiLogo;
		case Constants.VivoURL:
			return VivoLogo;
		case Constants.HisenseURL:
			return HisenseLogo;
	}
};

export const getStatusBarContentColor = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return "light-content";
		case Constants.VivoURL:
			return "dark-content";
		case Constants.HisenseURL:
			return "light-content";
	}
};

export const getInfoPageBackgroundColor = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return "#F5F5F5";
		case Constants.VivoURL:
			return "#fff";
		case Constants.HisenseURL:
			return "#fff";
	}
};

export const getBrandCheckbox = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return checkboxXiaomi;
		case Constants.VivoURL:
			return checkboxVivo;
		case Constants.HisenseURL:
			return checkboxHisense;
	}
};

export const getBrandLoginImage = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return XiaomiLogin;
		case Constants.VivoURL:
			return VivoLogin;
		case Constants.HisenseURL:
			return HisenseLogin;
	}
};

export const getCarouselImages = () => {
	const Vivo = [
		{
			id: "1",
			img: require("../../assets/Vivo-how/Vivo-step1.png"),
		},
		{
			id: "2",
			img: require("../../assets/Vivo-how/Vivo-step2.png"),
		},
		{
			id: "3",
			img: require("../../assets/Vivo-how/Vivo-step3.png"),
		},
		{
			id: "4",
			img: require("../../assets/Vivo-how/Vivo-step4.png"),
		},
		{
			id: "5",
			img: require("../../assets/Vivo-how/Vivo-step5.png"),
		},
		{
			id: "6",
			img: require("../../assets/Vivo-how/Vivo-step6.png"),
		},
	];

	const Hisense = [
		{
			id: "1",
			img: require("../../assets/Hisense-how/Step1.png"),
		},
		{
			id: "2",
			img: require("../../assets/Hisense-how/Step2.png"),
		},
		{
			id: "3",
			img: require("../../assets/Hisense-how/Step3.png"),
		},
		{
			id: "4",
			img: require("../../assets/Hisense-how/Step4.png"),
		},
		{
			id: "5",
			img: require("../../assets/Hisense-how/Step5.png"),
		},
		{
			id: "6",
			img: require("../../assets/Hisense-how/Step6.png"),
		},
	];

	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return Vivo;
		case Constants.VivoURL:
			return Vivo;
		case Constants.HisenseURL:
			return Hisense;
	}
};

export const getBrandSupportNumber = () => {
	switch (Constants.CIP_BRAND) {
		case Constants.XiaomiURL:
			return "011 504 0010";
		case Constants.VivoURL:
			return "011 504 0011";
		case Constants.HisenseURL:
			return "0861 23123";
	}
};
